import createErrors from '../createErrors';
import { type Page } from './constants';

export type Component = 'Main' | 'AOSList';

/**
 * Errors related to the AOS page
 */
export const Errors = createErrors<Page, Component>('AOS')({
    Main: {
        GetUserInfoError: {
            severity: 'MEDIUM',
            message: 'Failed to get user information from Okta.',
        },
        FetchCustomersError: {
            severity: 'MEDIUM',
            message: 'Failed to fetch customers from AOS.',
        },
        GetTokenError: {
            severity: 'MEDIUM',
            message: 'Failed to get token.',
        },
    },
    AOSList: {
        MergeCartError: {
            severity: 'MEDIUM',
            message: 'Failed to merge cart.',
        },
        FetchUserError: {
            severity: 'MEDIUM',
            message: 'Failed to fetch user information.',
        },
        AccountStatusError: {
            severity: 'MEDIUM',
            message: 'Failed to fetch Auth0 account status.',
        },
        UnlockAccountError: {
            severity: 'MEDIUM',
            message: 'Failed to unlock Auth0 account.',
        },
    },
});
